export default {
  main: {
    title: '中化学日本総合研究所'
  },
  menu: {
    new: 'ニュース',
    news: 'ニュース',
    newsList: 'ニュース',
    acti: '事業紹介',
    actiEdit: '事業紹介',
    contactUs: 'お問い合わせ',
    about: '会社概要',
    recruit: '採用情報',
    home: 'ホーム',
    technology: '研究開発',
    search: 'サイト内検索'
  },
  home: {
    technology: '研究開発',
    technologyName1: '銀ナノワイヤ透明導電フィルム',
    technologyName2: 'ポリイミド',
    technologyName3: '生分解性プラスチック',
    technologyName4: '高効率触媒',
    technologyName5: '水素エネルギーの貯蔵・輸送',
    technologyName6: 'マイクロリアクター',
    technologyContent1: '高い導電性と透過性及び良好な屈曲性を有するフレキシブルディスプレイ透明導電フィルム用の優れた材料です。',
    technologyContent2: '化学薬品に対する優れた耐食性、高い耐熱性及び機械的特性を有するため、最も有望な高分子材料の一つと考えられています。',
    technologyContent3: '太陽光或いは微生物の働きによって低分子物質に分解されるため、自然環境下で無害な物質になります。',
    technologyContent4: '環境保護分野に注力し、大気中の有害成分の高効率な転換と除去に取り組み、空を汚れのないきれいな青空とすることに貢献します。',
    technologyContent5: '発熱量が高く、燃焼後は水になる、地球上で最もクリーンなエネルギー源である水素は、地球上に豊富に存在する持続可能なエネルギー資源となります。',
    technologyContent6: 'マイクロリアクターによる連続フロー式反応を採用することによって、副生成物を最大限抑制し、省エネルギー化と操作の安全性向上を実現することが可能です。',
    project: '工程业绩',
    projectName1: '化学工程',
    projectName2: '炼油工程',
    projectName3: '能源工程',
    projectName4: '环保工程',
    projectName5: '轻工 医药 市政',
    projectName5_1: '轻工',
    projectName5_2: '医药 市政',
    projectContent1: '中国化学拥有丰富的化工工程经验，尤其是在传统化工、新型煤化工、石油化工、化工新材料等多个领域掌握并拥有成系列的专利技术和专有技术。可提供从规划、可研、设计、采购、施工、开车等全过程工程服务，工程建设质量均达到国内和国际先进水平。',
    projectContent2: '中国化学是国内最早开展炼油工程设计、建设的企业，参与建设了国内许多大、中型炼油工程项目。',
    projectContent3: '中国化学利用在化学工程技术上的自身优势，在能源储运、电站建设领域同样具有丰富的经验, 在国内外创造了骄人的业绩。',
    projectContent4: '中国化学拥有一支专业的环保技术研发队伍，多次参加省部、国家级科技攻关，具有多项技术，尤其是在国内工业污水治理领域具有丰富的经验。',
    projectContent5: '中国化学利用自身管理、设计、施工的优势，积极参与了港口、道路交通、房屋建筑、轻工、医药、市政等领域的建设，以优良的工程质量贏得了广泛赞誉。',
    news: 'ニュース',
    NewsRelease: '最新情報',
    business: '事業内容',
    subTitle1: '社会のための技術',
    subTitle2: '未来のための革新'
  },
  about: {
    title: '会社概要',
    name: '中化学日本総合研究所',
    name1: '沿革（グループ全体）',
    name2: '组织架构',
    name3: '关于公司',
    name4: 'コンタクト先',
    name5: '会社概况',
    name6: '基本信息',
    developHistory: '中国国家重工業部が中国化学の前身にあたる重工業設計院と建設公司を設立',
    developHistory1: '「中国化学工程総公司」を社名として、北京市にて法人登記',
    developHistory2: '「中国化学工程集団公司」に社名変更',
    developHistory3: '上海証券取引所に上場、略称「中国化学」（証券コード　601117）',
    developHistory4: '「3ヵ年5ヵ年計画、10ヵ年30ヵ年ビジョン目標」を発表、科学技術と事業を重要発展戦略として挙げ、同年6月、科研総院と日本分院をそれぞれ北京と東京において法人設立。中化学日本総合研究所と呼ばれる。',
    // time: '設立年月日',
    // local: '所在地',
    // number: '従業員数',
    // legal: '法人代表',
    // capital: '資本金',
    // businessContent: '事業内容',
    // businessContentValue1: '1.化学、素材、エネルギー、環境保護、ヘルスケアなどの分野に関する技術開発および調査研究。',
    // businessContentValue2: '2.上記分野における技術および製品のプロモーション、技術コンサルティング、技術成果のライセンス授与と譲渡移転。',
    // businessContentValue3: '3.上記分野における製品の輸出入貿易と代理販売（毒物劇物の製造・輸入業務を含む）。',
    // businessContentValue4: '4.上記分野における企業への投資及びM＆Aマッチング支援事業。',
    lable1: '商号',
    lable2: '本社',
    lable3: '代表者',
    lable4: '設立',
    lable5: '资本金',
    lable6: '株主総数',
    lable7: '株主',
    lable8: '従業員数',
    lable9: '事業内容',
    lable10: '主要取引銀行',
    tablename1: '株式会社中化学日本総合研究所',
    tablename2: '〒100-0005　東京都千代田区丸の内2-3-2郵船ビルディング',
    tablename3: '代表取締役　高小放',
    tablename4: '2019年6月18日',
    tablename5: '4億9,000万',
    tablename6: '1名（2022年3月末時点）',
    tablename7: '中国化学工程股份有限公司',
    tablename8: '50名（2022年現在）',
    tablename9: '1.化学、素材、エネルギー、環境保護、ヘルスケアなどの分野に関する技術開発および調査研究。\n' + 
                '2.上記分野における技術および製品のプロモーション、技術コンサルティング、技術成果のライセンス授与と譲渡移転。\n' + 
                '3.上記分野における製品の輸出入貿易と代理販売（毒物劇物の製造・輸入業務を含む）。\n' + 
                '4.上記分野における企業への投資及びM＆Aマッチング支援事業。',
    tablename10: '三井住友銀行\n' + '中国建設銀行',
    timeValue: '2019年6月18日',
    localValue: '东京办公室〉東京都品川区西五反田8-1-3 PMO五反田10F',
    numberValue: '50名（2022年現在）',
    legalValue: '高小放',
    capitalValue: '4億9,000万円',
    local1: 'つくば研究開発センター：',
    localValue1: '茨城県つくば市東光台5-9-1',
    localValue2: '東京都千代田区丸の内２丁目３-２ 郵船ビルディング 710室',
    telValue2: '03-5220-8899',
    faxValue2: '03-5220-9011',
    tel: 'Tel',
    telValue: '029-846-3481',
    fax: 'Fax',
    faxValue: '029-847-4550',
    purpose: '用途',
    purposeValue: '自主研发及共同研发',
    area: '面积',
    areaValue: '1,000 ㎡',
    eMail: 'E-mail',
    eMailValue: 'admin@cncec-jri.com',
    eMailValue2: 'admin@cncec-jri.com',
    message: {
      name: 'お名前',
      namePinyin: 'フリガナ',
      eMail: 'E-mail',
      fax: '传真',
      telephone: '電話番号',
      companyName: '会社名',
      content: 'お問い合わせ内容',
      securityCode: '認証コード',
      agree: '同意する',
      agreeContent: '上記個人情報の利用目的および当社プライバシーポリシーについて 同意いただける場合は、「同意する」にチェックを付け「送信する」ボタンをクリックして下さい。',
      submit: '送信'
    },
    project: {
      title: '8 家工程公司',
      company1: '1. 中国天辰工程有限公司',
      company2: '2. 赛鼎工程有限公司',
      company3: '3. 东华工程科技股份有限公司',
      company4: '4. 中国五环工程有限公司',
      company5: '5. 华陆工程科技有限责任公司',
      company6: '6. 中国成达工程有限公司',
      company7: '7. 中国化学工业桂林工程有限公司',
      company8: '8. 化学工业岩土工程',
    },
    build: {
      title: '10 家建设公司',
      company1: '1. 中化二建集团有限公司',
      company2: '2. 中国化学工程第三建设有限公司',
      company3: '3. 中国化学工程第四建设有限公司',
      company4: '4. 中国化学工程第六建设有限公司',
      company5: '5. 中国化学工程第七建设有限公司',
      company6: '6. 中国化学工程第九建设有限公司',
      company7: '7. 中国化学工程第十一建设有限公司',
      company8: '8. 中国化学工程第十三建设有限公司',
      company9: '9. 中国化学工程第十四建设有限公司',
      company10: '10. 中国化学工程第十六建设有限公司',
    },
    hold: {
      title: '控股参股公司',
      company1: '1. 四川晟达化学新材料有限责任公司',
      company2: '2. 印尼中化巨港电站有限公司',
      company3: '3. 中化工程集团财务有限公司',
      company4: '4. 中化工程集团环保有限公司',
      company5: '5. 中国化学科学技术研究院',
    },
    contact: {
      address: '所在地:',
      tell: 'Tel:',
      addressName: '東京都品川区西五反田8-1-3　PMO五反田10F',
      phone: '03-57192660'
    }
  },
  acti: {
    title: '事業紹介',
    name: '中化学日本総合研究所',
    name3: 'つくば研究開発センター',
    name1: '拠点紹介',
    name2: 'ACTI业务模式',
    name4: '本社',
    name5: '横浜研究開発センター',
    businessName1: '新素材',
    businessContent1: 'エンジニアリングプラスチック、電子化学品、特殊ゴム、高性能繊維',
    businessName2: 'グリーンエネルギー',
    businessContent2: '水素エネルギー、太陽エネルギー、バイオエネルギー',
    businessName3: '環境保護',
    businessContent3: '排水・排ガス・産業廃棄物処理、カーボンニュートラル、生分解性材料',
    businessName4: '化学プロセス技術',
    businessContent4: '省エネ・インテリジェント設備 ',
    modeName1: '技术引进',
    modeContent1: '定位填补国内空白和国内亟待升级换代的产品和技术，以技术合作的方式引进技术。',
    modeName2: '联合开发',
    modeContent2: '与日本当地工业科技企业及高校科研机构合作的共同开发课题。',
    modeName3: '自主研发',
    modeContent3: '着眼未来技术发展趋势，布局下一代产品和技术，培育自主技术。',
    modeName4: '投资并购',
    modeContent4: '对日本行业内相关的初创技术公司进行并购。',
    content: '<b style="width: 114px">成立时间：</b>2019年6月18日<br>' +
              '<div class="d-flex"><b style="width: 114px">所在地：</b><p>东京办公室〉東京都品川区西五反田8-1-3 PMO五反田10F</p></div><br>' +
              '<b style="width: 114px">员工数：</b>45人<br>' +
              '<b style="width: 114px">法人代表：</b>高小放<br>' +
              '<b style="width: 114px">注册资本：</b>4億9000万日元<br>'
  },
  recruit: {
    title: '採用情報',
    info: '募集情報',
    name: '职位名称',
    local: '工作地点',
    number: '招聘人数',
    time: '更新时间',
    rank: '職階',
    numberPeople: '管理人数',
    numberManagers: '所属部門',
    supervisor: '上級主管',
    arriveTime: '勤務時間が欲しいです',
    applyNow: '応募する',
  },
  news: {
    title: 'ニュース',
    allNews: '全ての情報',
    newsRelease: '最新情報'
  },
  newsList: {
    title: 'ニュース'
  },
  organizational: {
    title: 'ACTIつくば实验室',
    name: '实验室外部和内部'
  },
  search: {
    name: '搜索结果',
    title: 'サイト内検索',
    btn: 'サイト内検索',
    noInfo: '検索情報はありません',
  },
  project: {
    title: '工程业绩',
    project1: '神华MTO项目',
    project2: '拜尔TDI项目',
    project3: '越南尿素合成氨项目',
    project4: '福建己内酰胺项目',
    project5: '新疆独山子炼油项目',
    project6: '巴基斯坦柴油加氢',
    project7: '上海LNG接收站项目',
    project8: '格鲁吉亚联合循环电站',
    project9: '上海废料焚烧处理项目',
    project10: '内蒙古神华CCS项目',
    project11: '缅甸造纸厂项目',
    project12: '诺和诺德生物制药厂项目',
  },
  business: {
    technology: '技術連携',
    joint: '共同開発',
    independent: '自主開発',
    investment: 'M&A',
    technologyContent: '日本企業との技術連携を通した中国市場をターゲットとした技術開発。',
    jointContent: '大学・研究機関及び企業との共同研究成果を事業化する。',
    independentContent: '未来を見据えた技術開発、次世代製品の創出。 ',
    investmentContent: '先進技術分野におけるスタートアップ企業への投資活動。',
  },
  technology: {
    title: '研究開発'
  },
  footer: {
    help: {
      title: 'お問い合わせ',
      question: 'サポート',
      answers: '',
      contactNow: 'よくあるご質問',
      phone: 'Tel',
      process: '如果您对我们的服务或流程感到不满意，有任何意见或投诉，请与通过以下方式与我们联系',
      links: '友情链接:',
      contactUs: '連絡先',
      tel: 'Tel: ',
      fax: 'Fax: ',
      eMail: 'E-mail: '
    },
    confirm: 'わかりました',
    privacyPolicy: 'プライバシーポリシー'
  },
  common: {
    building: '建設中',
    viewDetails: '詳細',
    more: 'もっと',
    contact: 'お問い合わせ先',
    searchTitle: '検索タイトルを入力してください',
    phoneNotEmpty: '携帯電話番号は必ず入力してください',
    pleaseEnterPhone: '正しい電話番号を入力してください',
    pleaseEnterContent: '内容を入力してください',
    pleaseEnterSecurityCode: '認証コードを入力してください',
    submitSuccess: '正常に送信されました',
    verificationCodeError: '認証コードエラー'
  }
}



// WEBPACK FOOTER //
// ./src/lang/jp.js